import FrontendDetectionHelper from './FrontendDetectionHelper';
let apm;
export const ApmSpanType = Object.freeze({
    UNKNOWN: 'UNKNOWN',
    PURE_FUNCTION: 'pureFunction',
    BIFROST_BACKEND: 'bifrostBackend',
});
function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.toLowerCase().slice(1);
}
function normalizeError(error) {
    if (!FrontendDetectionHelper.isFrontend)
        return;
    if (error.errorCode)
        return error.errorCode;
    let errorMessage = undefined;
    switch (error.name) {
        case 'TypeError':
        case 'ReferenceError': {
            const messages = ['Cannot read property', 'is not a function', 'is not defined', 'null is not an object'];
            for (const message of messages) {
                const re = new RegExp(message, 'ig');
                const normilizedMessage = error.message.trim().match(re);
                if (normilizedMessage) {
                    errorMessage = normilizedMessage[0];
                    break;
                }
            }
            break;
        }
        case 'Error': {
            errorMessage = error.message;
            break;
        }
    }
    return errorMessage ? capitalizeFirstLetter(errorMessage) : errorMessage;
}
export const ApmHelper = {
    setApm(apmInstance, { tenantId = undefined, channel = undefined, track = undefined } = {}) {
        if (!apmInstance)
            throw new Error('Apm has not been defined.');
        apm = apmInstance;
        const labels = Object.assign(Object.assign(Object.assign({}, (tenantId ? { tenant: `tid${tenantId}` } : {})), (channel ? { channel } : {})), (track ? { track } : {}));
        apm.addLabels(labels);
    },
    addLabel(key, value) {
        if (this.isEnabled()) {
            apm.addLabels({ [key]: value });
        }
    },
    captureError(error, details) {
        if (this.isEnabled()) {
            const errorMessage = normalizeError(error);
            const errorLabels = Object.assign(Object.assign(Object.assign({}, (error.errorCode ? { errorCode: error.errorCode } : {})), (error.name ? { errorName: error.name } : {})), (errorMessage ? { errorMessage: errorMessage } : {}));
            apm.getCurrentTransaction().addLabels(errorLabels);
            const customContext = Object.assign(Object.assign(Object.assign(Object.assign({}, (error.message ? { errorMessage: error.message } : {})), (error.type ? { errorType: error.type } : {})), (error.errorData ? { errorData: error.errorData } : {})), (details || {}));
            apm.setCustomContext(customContext);
            apm.captureError(error);
        }
    },
    addCustomContext(key, value) {
        if (this.isEnabled()) {
            apm.setCustomContext({ [key]: value });
        }
    },
    setUserContext(key, value) {
        if (this.isEnabled()) {
            apm.setUserContext({ [key]: value });
        }
    },
    isEnabled() {
        return apm ? (apm.isEnabled !== undefined ? apm.isEnabled : apm.isStarted()) : false;
    },
    startSpan(name, type = ApmSpanType.UNKNOWN, options) {
        const { transaction = undefined } = options;
        const fallbackRetObj = {
            end: () => undefined,
        };
        if (this.isEnabled()) {
            if (transaction && transaction.ended) {
                return fallbackRetObj;
            }
            const span = transaction && typeof transaction.startSpan === 'function'
                ? transaction.startSpan(name, type)
                : apm.startSpan(name, type);
            return span ? span : fallbackRetObj;
        }
        return fallbackRetObj;
    },
    getCurrentTransaction() {
        if (this.isEnabled()) {
            return apm.getCurrentTransaction ? apm.getCurrentTransaction() : apm.currentTransaction;
        }
        return undefined;
    },
    getCurrentTraceIds() {
        if (this.isEnabled()) {
            return apm.currentTraceIds;
        }
        return undefined;
    },
    startTransaction(name, type = ApmSpanType.UNKNOWN) {
        const fallbackRetObj = {
            end: () => undefined,
        };
        if (this.isEnabled()) {
            const tr = apm.startTransaction(name, type);
            return tr ? tr : fallbackRetObj;
        }
        return fallbackRetObj;
    },
    apmDecorator(fn, { apmLabel = '', apmType = '', loggingEnabled = true, transaction = undefined } = {}) {
        const wrapper = function (origin) {
            return function (...args) {
                const span = ApmHelper.startSpan(apmLabel, apmType, { transaction });
                try {
                    return origin(...args);
                }
                finally {
                    span.end();
                }
            };
        };
        if (loggingEnabled) {
            return wrapper(fn);
        }
        else {
            return fn;
        }
    },
};
